<template>
  <div>
    <!-- <div class="field-row">
        <input type="text" v-model="title" name="" id="" placeholder="Category name" />
    </div>
    <div class="field-row">
        <Textarea v-model="description" placeholder="description"></Textarea>
    </div>
    <div class="field-row">
        <button @click.prevent="savedata">Save</button>
    </div> -->
    <a-modal v-model="visible" title="Edit Product Details" onOk="handleOk">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleEdit">Edit Product</a-button>
      </template>
      <a-form class="mb-4" :form="form">
        <div class="row">
          <div class="col-md-6">
            <a-form-item label="Select category">
              <a-select
                placeholder="Select category"
                v-decorator="['category_id', { rules: [{ required: true, message: 'Please select a category!'}]}]"
                @change="handleCategorySelect"
              >
                <a-select-option v-for="(cat, index) in categories" :key="index" :value="cat.id">{{cat.name}}</a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <div class="col-md-6">
            <a-form-item label="Select sub category">
              <a-select
                placeholder="Select sub category"
                v-decorator="['sub_category_id', { rules: [{ required: false, message: 'Please select a sub category!'}]}]"
              >
                <a-select-option v-for="(cat, index) in subCategories" :key="index" :value="cat.id">{{cat.name}}</a-select-option>
              </a-select>
            </a-form-item>
          </div>
        </div>
        <a-form-item label="Product Title">
            <a-input
                placeholder="Product title"
                v-decorator="['name', {rules: [{ required: true, message: 'Please input product name!' }, {max: 30, message: 'Must not exceed 30 characters!'}]}]"
            />
        </a-form-item>
        <div class="row">
          <div class="col-md-6">
            <a-form-item label="Product Code">
              <a-input
                placeholder="Product code. eg: SKU1129930"
                v-decorator="['code', {rules: [{ required: true, message: 'Please input product code!' }, {max: 30, message: 'Must not exceed 30 characters!'}]}]"
              />
            </a-form-item>
          </div>
          <div class="col-md-6">
            <a-form-item label="Selling Price">
              <a-input-number
                style="width: 100%"
                placeholder="Set the selling price"
                v-decorator="['selling_price', {rules: [{ required: false, message: 'Please input product code!' }]}]"
              />
            </a-form-item>
          </div>
        </div>
        <a-form-item label="Class">
          <a-select
            v-decorator="[
                    'class_id',
                    {rules: [{ required: false, message: 'Please select a class!!' }], initialValue: 0}
                  ]"
            placeholder="Select class"
          >
            <a-select-option :value="0">
              Select Class
            </a-select-option>
            <template v-for="schoolClass in schoolClasses">
              <a-select-option :value="schoolClass.id" :key="schoolClass.id">
                {{schoolClass.name}}
              </a-select-option>
            </template>
          </a-select>
        </a-form-item>
        <div class="row">
          <div class="col-md-6">
            <a-form-item label="Minimum Quantity">
              <a-input-number
                style="width: 100%"
                placeholder="Add Minimum Quantity"
                v-decorator="['minimum_quantity', {rules: [{ required: false, message: 'Please input minimum quantity!' }]}]"
              />
            </a-form-item>
          </div>

          <div class="col-md-6">
            <a-form-item label="Maximum Quantity">
              <a-input-number
                style="width: 100%"
                placeholder="Add Maximum Quantity"
                v-decorator="['maximum_quantity', {rules: [{ required: false, message: 'Please input maximum quantity!' }]}]"
              />
            </a-form-item>
          </div>
        </div>

        <a-form-item label="Description">
            <a-textarea placeholder="Description" :autosize="{minRows: 2}" v-decorator="['description', {rules: [{max: 100, message: 'Must not exceed 100 characters!'}]}]" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
// import { fetchInventoryData } from '@/components/inventory/common'
export default {
  name: 'EditProduct',
  data: function () {
    return {
      form: this.$form.createForm(this),
      visible: false,
      loading: false,
      oldrecord: {},
      newrecord: {},
      allCategories: [], // All categories including sub categories
      categories: [], // Only the main categories i.e. without subcategories
      subCategories: [],
      schoolClasses: [],
    }
  },
  mounted: function () {
    /* let d = fetchInventoryData('category')
    d.then(data => { this.categories = data.data }).catch(err => console.error(err)) */
    this.getParentCategories()
    this.$eventBus.$on('openEditForm', this.showForm)
  },
  methods: {
    getParentCategories: function() {
      this.$http.get('/api/inventory/category')
        .then(({ data }) => {
          this.allCategories = data.data
          this.categories = this.allCategories.filter((category) => category.parent_category_id === null)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getSubCategories: function(selectedCategoryId) {
      this.subCategories = this.allCategories.filter((category) => category.parent_category_id === selectedCategoryId)
    },
    handleCategorySelect: function(selectedCategoryId) {
      console.log('selectedCategoryId:: ', selectedCategoryId)
      this.form.setFieldsValue({
        'sub_category_id': undefined,
      })
      this.getSubCategories(selectedCategoryId)
    },
    showForm: function(record) {
      console.log('Record', record)
      this.visible = true
      this.getClasses()
      this.getSubCategories(record.category_id)
      // console.log('passed record', record)
      this.oldrecord = record
      setTimeout(() => {
        this.form.setFieldsValue({
          'name': record.name,
          'description': record.description,
          'code': record.code,
          'category_id': record.category_id,
          'sub_category_id': record.sub_category_id,
          'class_id': record.class_id,
          'selling_price': record.selling_price,
          'min_quantity': record.product_stock,
          'max_quantity': record.product_stock.max_quantity,
        })
      }, 50)
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
    getClasses: function() {
      this.$http.get('/api/class')
        .then(({ data }) => {
          this.schoolClasses = data.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleEdit() {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('old data', this.oldrecord)
          console.log('formdata', values)
          this.$http
            .patch(`/api/inventory/product/${this.oldrecord.id}`, {
              name: values.name,
              code: values.code,
              description: values.description,
              category_id: values.category_id,
              sub_category_id: values.sub_category_id,
              class_id: values.class_id,
              selling_price: values.selling_price ? values.selling_price : 0.0,
              status: 1,
              min_quantity: values.minimum_quantity,
              max_quantity: values.maximum_quantity,
            })
            .then((resp) => {
              if (resp.status === 200) {
                this.loading = false
                this.visible = false
                this.$emit('onEdited')
                this.$notification['success']({
                  message: 'Successfully edited',
                  description: 'Product details edited successfully!',
                })
              } else {
                this.$notification['warning']({
                  message: 'Unknown Error',
                  description: 'There appears to be an error while submitting data.',
                })
              }
              this.form.resetFields()
            })
            .catch(error => {
              this.$neoNotify.error(error)
            })
        }
      })
      this.loading = false
    },
  },
}
</script>

<style>

</style>
